//import {MindboxTracker} from './mindbox';
import {DataLayerTracker} from './datalayer';
import {AdmitAdRetargetingTracker} from './admitad-retargeting';
//import {MailRuTracker} from './mailru';
//import {MailRuNewTracker} from './mailrunew';
//import {GoogleRemarketingTracker} from './google-remarketing';
//import {FacebookTracker} from './facebook';
import {AdmitAdV2Tracker} from './admitadv2';
//import {AdSpireTracker} from './adspire';
import {RetailRocket} from './retailrocket';
//import {Addigital} from './addigital';
import {Vk} from './vk';
//import {AddigitalMgid} from './addigital-mgid';
//import {LeelooTracker} from './leeloo';
import {Flocktory} from './flocktory';
import {GoogleRemarketingTag} from './google-remarketing-tag';
import {WhereElephantCpa} from './where-elephant-cpa';

/**
 * На бекенде инициализируется набор данных для аналитики. Будем использовать его в качестве контейнера для хранения
 * данных и будем раздавать оттуда данные для аналитических сервисов и CPA партнеров
 */
export class Tracker {
    constructor(data) {
        this.data = data;
        this.dataLayer = new DataLayerTracker(data);
        this.admitAdRetargeting = AdmitAdRetargetingTracker;
        //this.mailru = new MailRuTracker();
        //this.mailrunew = new MailRuNewTracker();
        this.googleRemarketingTag = new GoogleRemarketingTag();
        this.admitAdV2 = AdmitAdV2Tracker;
        //this.AdSpire = AdSpireTracker;
        this.retailrocket = new RetailRocket();
        //this.addigital = new Addigital();
        this.vk = new Vk();
        //this.addigitalMgit = new AddigitalMgid();
        //this.leelooTracker = new LeelooTracker();
        this.flocktory = new Flocktory();
        this.whereElephantCpa = new WhereElephantCpa();

        //this.facebook = new FacebookTracker();
        //this.mindbox = new MindboxTracker();
        //this.googleRemarketing = new GoogleRemarketingTracker();

        this.init();
        this.backendPageViewed();
    }

    init() {
        this.admitAdRetargeting.init();
        this.dataLayer.init();
        //this.mailru.init();
        //this.mailrunew.init();
        this.admitAdV2.init();
        this.flocktory.init();
        this.whereElephantCpa.init();
    }

    isUserAuthorized() {
        return this.data.user.authorized;
    }

    getCurrency() {
        return this.data.currency;
    }

    backendPageViewed() {
        switch (this.data.route) {
            case 'index':
                this.indexPageViewed();
                break;
            case 'products':
                this.categoryPageViewed();
                break;
            case 'product':
                this.productPageViewed();
                break;
            case 'cart':
                this.basketPageViewed();
                break;
            case 'order':
                this.orderPageViewed();
                break;
            // это фейковый маршрут, но страница эта отдельная
            case 'order.thankyoupage':
                this.orderThankyouPageViewed();
                break;
            // также является фейковым маршрутом
            case 'encyclopedia_pages.article':
                this.articlePageViewed();
                break;
            case '404':
                this.notFoundPageViewed();
                break;
            case 'search':
                this.searchPageViewed();
                break;
            case 'landing':
                this.landingPageViewed();
                break;
            default:
                this.otherPageViewed();
                break;
        }
    }

    landingPageViewed() {
        //this.leelooTracker.landingView();
    }

    registerPageViewed() {
        this.admitAdRetargeting.registerPageView();
        //this.mailru.otherPageView();
        //this.mailrunew.otherPageView();
        //this.facebook.lead();
        //this.addigitalMgit.otherPageViewed();
    }

    indexPageViewed() {
        this.admitAdRetargeting.indexPageView();
        //this.mailru.indexPageView();
        //this.mailrunew.indexPageView();
        this.googleRemarketingTag.indexPageView();
        //this.addigital.indexPageView();
        //this.addigitalMgit.otherPageViewed();
        this.whereElephantCpa.indexPageView(this.data);

        //this.googleRemarketing.indexPageView();
    }

    categoryPageViewed() {
        this.admitAdRetargeting.categoryPageView(this.data.category);
        //this.mailru.categoryPageView(this.data.products);
        //this.mailrunew.categoryPageView(this.data.products);
        this.googleRemarketingTag.categoryPageView(this.data.products);
        this.dataLayer.categoryPageView(this.data.products);
        this.retailrocket.viewContentCategory(this.data.category);
        //this.addigital.categoryPageView();
        //this.addigitalMgit.otherPageViewed();
        this.whereElephantCpa.categoryPageView(this.data)

        //this.facebook.viewContentCategory(this.data.category);
        //this.googleRemarketing.categoryPageView(this.data.products);
        //this.mindbox.categoryPageView(this.data.category);
    }

    productPageViewed() {
        this.admitAdRetargeting.productPageView(this.data.product);
        this.dataLayer.productPageView(this.data.product);
        //this.mailru.productPageView(this.data.product);
        //this.mailrunew.productPageView(this.data.product);
        this.googleRemarketingTag.productPageView(this.data.product);
        this.retailrocket.viewContentProduct(this.data.product);
        //this.addigital.productPageView(this.data.product);
        this.vk.productPageView(this.data.product);
        //this.addigitalMgit.productPageViewed(this.data.product);
        //this.leelooTracker.productView();
        this.whereElephantCpa.productPageView(this.data);

        //this.facebook.viewContentProduct(this.data.product);
        //this.googleRemarketing.productPageView(this.data.product);
        //this.mindbox.productPageView(this.data.product);
    }

    basketPageViewed() {
        this.admitAdRetargeting.basketPageView(this.data.basket);
        this.dataLayer.basketPageView(this.data.basket);
        //this.mailru.basketPageView(this.data.basket);
        //this.mailrunew.basketPageView(this.data.basket);
        //this.addigital.basketPageView(this.data.basket);
        this.vk.basketPageView(this.data.basket);
        //this.addigitalMgit.otherPageViewed();
        this.googleRemarketingTag.basketPageView(this.data.basket);
        this.whereElephantCpa.basketPageView(this.data);

        //this.googleRemarketing.basketPageView(this.data.basket);
    }

    productAddToFavorite(params) {
        //this.facebook.addToWishlist();
        this.dataLayer.push({'event': 'PMbtnWish'});
        this.retailrocket.productAddToFavorite(params);
    }

    orderPageViewed() {
        this.admitAdRetargeting.orderPageView();
        this.dataLayer.orderPageView(this.data.basket);
        //this.mailru.orderPageView();
        //this.mailrunew.orderPageView();
        //this.addigital.orderPageView();
        //this.addigitalMgit.otherPageViewed();

        //this.facebook.initiateCheckout();
        //this.googleRemarketing.orderPageView();
    }

    orderThankyouPageViewed() {
        this.admitAdRetargeting.orderThankyouPageView(this.data.order, this.data.basket);
        this.dataLayer.orderThankyouPageView(this.data.order, this.data.basket);
        //this.mailru.orderThankyouPageView(this.data.basket);
        //this.mailrunew.orderThankyouPageView(this.data.basket);
        this.admitAdV2.orderThankyouPageView(this.data.order, this.data.basket, this.data.user);
        //this.AdSpire.orderThankyouPageView(this.data.order, this.data.basket, this.data.user);
        this.retailrocket.orderTransaction(this.data.order, this.data.basket, this.data.user);
        //this.addigital.orderThankyouPageView(this.data.basket);
        this.vk.orderThankyouPageView(this.data.basket);
        //this.addigitalMgit.orderThankyouPageView(this.data.basket);
        //this.leelooTracker.orderThankyouPageView();
        this.flocktory.postcheckout(this.data.order, this.data.basket, this.data.user);
        this.googleRemarketingTag.orderCreated(this.data.basket);

        //this.facebook.purchase(this.data.order);
        //this.facebook.leadOrder(this.data.order);
        //this.googleRemarketing.orderThankyouPageView(this.data.basket);
        //this.mindbox.orderCreated(this.data.order, this.data.basket, this.data.user);
    }

    articlePageViewed() {
        //this.facebook.viewContent();
        //this.addigitalMgit.otherPageViewed();
    }

    searchPageViewed() {
        //this.mailru.searchPageView();
        //this.mailrunew.searchPageView();
        //this.facebook.search();
        //this.addigital.searchPageView();
        //this.addigitalMgit.otherPageViewed();
        this.googleRemarketingTag.searchPageView(this.data.products);

        //this.googleRemarketing.searchPageView();
    }

    otherPageViewed() {
        //this.mailru.otherPageView();
        //this.mailrunew.otherPageView();
        //this.addigitalMgit.otherPageViewed();
        this.googleRemarketingTag.otherPageViewed();
        this.whereElephantCpa.otherPageView(this.data);
    }

    notFoundPageViewed() {
        //this.mailru.otherPageView();
        //this.mailrunew.otherPageView();
        this.whereElephantCpa.otherPageView(this.data);
    }

    userRegisteredMain(user) {
        this.dataLayer.push({'event': 'Registration_Done'});
        //this.mindbox.userRegistered(user);
        //this.facebook.completeRegistration();
    }

    userAuthorizedMain(user) {
        this.flocktory.updateCart(this.data.basket);
        //this.mindbox.userAuthorized(user);
    }

    userUpdatedProfilePersonal(user) {
        //this.mindbox.userUpdated(user);
    }

    subscriptionChangeClicked() {
        this.dataLayer.push({'event': 'Subscription_Button'});
    }

    subscriptionChanged(user) {
        /*if (this.data.route == 'index') {
            this.userSubscribedMainpage(subscription);
        }
        if (this.data.route == 'personal_account') {
            this.userSubscribedProfilePersonal(subscription);
        }*/
        this.dataLayer.push({'event': 'Subscription_Done'});
        //this.mindbox.userChangedSubscription(user);
        //this.facebook.newsletterSubscription();
        this.retailrocket.subscription(user.email);
    }

    subscriptionChangedPopup(user) {
        this.dataLayer.push({'event': 'Subscription_Done'});
        this.retailrocket.subscriptionPopup(user.email);
    }

    subscriptionPopupForms(email) {
        this.retailrocket.subscription(email);
    }

    userSubscribedProfilePersonal(subscription) {
        if (isDevelopment()) {
            //console.log(subscription);
        }
    }

    userSubscribedMainpage(subscription) {
        if (isDevelopment()) {
            //console.log(subscription);
        }
    }

    basketItemAddClicked() {
        this.dataLayer.push({'event': 'Add2Cart_Button'});
    }

    basketItemAdded(product) {
        this.dataLayer.basketItemAdd(product);
        //this.mindbox.basketItemAdded(product);
        //this.facebook.addToCart(product);
        this.retailrocket.addToCart(product);
        //this.addigital.addToCart(product);
        this.flocktory.addToCart(product);
    }

    basketItemUpdated(product) {
        //console.log('basketItemUpdated');
        //console.log(product);
        //this.mindbox.basketItemUpdated(product);
    }

    basketItemDeleted(product) {
        this.flocktory.removeFromCart(product);
    }

    basketUpdate(basketItems) {
        this.flocktory.updateCart(basketItems);
    }

    basketPageOpenCouponFormButtonClicked() {
        this.dataLayer.push({'event': 'coupon_link'});
    }

    basketPageCouponConfirmClicked() {
        this.dataLayer.push({'event': 'coupon_button'});
    }

    basketPageCouponApplied() {
        this.dataLayer.push({'event': 'coupon_Done'});
    }

    /*
    Этих событий нет на сайте сейчас
    basketPageContinueButtonClicked() {
        this.dataLayer.push({'event': 'basket_continue'});
    }

    basketPageRefreshButtonClicked() {
        this.dataLayer.push({'event': 'basket_refresh'});
    }*/

    basketPageOrderButtonClicked() {
        this.dataLayer.push({'event': 'basket_order'});
    }

    oneClickPopupOpened(productId) {
        this.dataLayer.push({'event': 'oneClick_buy_Button'});
        this.dataLayer.push({'event': 'PMfrmOneClick'});

        if (productId) {
            this.retailrocket.oneClick(productId);
        }
    }

    orderPageContactsTabClicked() {
        this.dataLayer.push({'event': 'contact_login'});
    }

    orderPageReload() {
        this.dataLayer.orderPageReload(this.data.basket);
    }

    orderPageOneClickOrderTabClicked() {
        this.dataLayer.push({'event': 'contact_1clickBuy'});
    }

    orderPageConfirmButtonClicked() {
        this.dataLayer.push({'event': 'confirm_order'});
    }

    orderPageRegisterTabClicked() {
        this.dataLayer.push({'event': 'contact_registration'});
    }

    orderPageLoyalityCardValidated(card) {
        this.dataLayer.orderPageLoyalityCardValidtion(card);
    }

    userSubmittedRegistration() {
        this.dataLayer.push({'event': 'contact_registration_continue'});
    }

    userSubmittedAuthorization() {
        this.dataLayer.push({'event': 'contact_login_continue'});
    }

    orderPageOneClickOrderButtonClicked() {
        this.dataLayer.push({'event': 'contact_1clickBuy_continue'});
        //this.facebook.buyOneClick();
    }

    /*orderCreated() {
        this.debug('orderCreated');
    }

    orderCreatedOneClick() {
        this.debug('orderCreatedOneClick');
    }*/

    productSubscribed(product, user) {
        //this.mindbox.productSubscribed(product, user);
    }

    callbackFormOpened() {
        this.dataLayer.push({'event': 'backcall'});
        this.dataLayer.push({'event': 'PMbtnCallMe'});
    }

    callbackFormSended() {
        this.dataLayer.push({'event': 'backcall_sent'});
        this.dataLayer.push({'event': 'PMfrmCallMe'});
        //this.facebook.requestCallBack();
    }

    onlineChatOpened() {
        this.dataLayer.push({'event': 'online_consultant'});
    }

    onlineChatMessageSended() {
        this.dataLayer.push({'event': 'online_consultant_button'});
    }

    productDescriptionTabOpened() {
        this.dataLayer.push({'event': 'description_tab'});
    }

    productAccessoriesTabOpened() {
        this.dataLayer.push({'event': 'accessories_tab'});
    }

    productReviewsTabOpened() {
        this.dataLayer.push({'event': 'reviews_tab'});
    }

    productFaqTabOpened() {
        this.dataLayer.push({'event': 'faq_tab'});
    }

    productAnalogsTabOpened() {
        this.dataLayer.push({'event': 'analogues_tab'});
    }

    shopsMapOpened() {
        this.dataLayer.push({'event': 'offline_map'});
    }

    clickButtonApplySmartFilter() {
        this.dataLayer.push({'event': 'PMbtnFilter'});
        //this.facebook.applyingFilter();
    }

    tooltipProduct(type) {
        if (type) {
            let eventName;
            switch (true) {
                case (type === 'delivery'):
                    eventName = 'PMbtnDelivery';
                    break;
                case (type === 'cards'):
                    eventName = 'PMbtnBonus';
                    break;
            }

            this.dataLayer.push({'event': eventName});
        }
    }

    reviewsAdd() {
        this.dataLayer.push({'event': 'PMfrmComment'});
        //this.facebook.addReview();
    }

    questionsAdd() {
        this.dataLayer.push({'event': 'PMfrmAsk'});
        //this.facebook.addQuestion();
    }

    productNotificationAdd() {
        this.dataLayer.push({'event': 'PMfrmNotice'});
        //this.facebook.productNotificationAdd();
    }

    selectedCity(cityName) {
        this.dataLayer.push({
            'event': 'PMbtnCity',
            'pmParam1': cityName.replace(/&quot;/g, ''),
        });
    }

    clickPointYandexMap(shopName) {
        this.dataLayer.push({
            'event': 'PMbtnCityItem',
            'pmParam1': shopName.replace(/&quot;/g, ''),
        });

        //this.facebook.selectedShop();
    }

    clickPhoneBox() {
        this.dataLayer.push({'event': 'PMbtnTel'});
    }

    clickSocialNetwork() {
        //this.facebook.clickSocialNetwork();
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/tracker.js